var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcRelay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 14.25L3.05 15.3L7.25 11.1L11.45 15.3L12.5 14.25L7.25 9L2 14.25ZM21.95 8.7L17.75 12.9L13.55 8.7L12.5 9.75L17.75 15L23 9.75L21.95 8.7ZM7.25 16.5C6.42155 16.5 5.75 17.1715 5.75 18C5.75 18.8285 6.42155 19.5 7.25 19.5C8.07845 19.5 8.75 18.8285 8.75 18C8.75 17.1715 8.07845 16.5 7.25 16.5ZM17.75 7.5C18.5784 7.5 19.25 6.82845 19.25 6C19.25 5.17155 18.5784 4.5 17.75 4.5C16.9215 4.5 16.25 5.17155 16.25 6C16.25 6.82845 16.9215 7.5 17.75 7.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRelay);
export default __webpack_public_path__ + "static/media/ic-relay.66db8140d006d6dbd016f52d8304d666.svg";
export { ForwardRef as ReactComponent };